/**
 * Construye las opciones de categorías para el multiselect de interés de un lead.
 *
 * Regla de negocio (front operaciones, Capaciter):
 *
 * - Toda categoría lleva SIEMPRE su género ('Hombre' / 'Mujer'). No existe la
 *   opción "sin género".
 * - Una categoría que exista en ambos géneros aparece DOS veces (una por género):
 *   "Camisas (Hombre)" y "Camisas (Mujer)" son opciones distintas, porque a la
 *   hora de filtrar el interés del contacto no es lo mismo.
 * - Si solo hay un género seleccionado (solo Caballero o solo Dama) → solo sus
 *   categorías. Si hay ambos o ninguno → la unión de Hombre + Mujer.
 *
 * El `value` codifica el género ("<categoría> (<Hombre|Mujer>)") para que sea
 * único y filtrable; `label` es la categoría limpia y `hint` el género (que el
 * multiselect pinta como "categoría · género" tanto en el desplegable como en
 * los tags seleccionados).
 *
 * Devuelve [{ value, label, hint }].
 */
export function buildCategoryOptions(caballero, dama, hombre, mujer) {
  const onlyHombre = caballero && !dama;
  const onlyMujer = dama && !caballero;

  const opts = [];
  const pushAll = (list, genderLabel) =>
    (list || []).forEach((c) => opts.push({ value: `${c} (${genderLabel})`, label: c, hint: genderLabel }));

  if (onlyHombre) {
    pushAll(hombre, 'Hombre');
  } else if (onlyMujer) {
    pushAll(mujer, 'Mujer');
  } else {
    // Ambos o ninguno: todas las de Hombre y todas las de Mujer. Las compartidas
    // quedan por duplicado a propósito (una opción por género).
    pushAll(hombre, 'Hombre');
    pushAll(mujer, 'Mujer');
  }

  return opts.sort((a, b) => a.label.localeCompare(b.label, 'es') || a.hint.localeCompare(b.hint, 'es'));
}
